import React, { useState, useMemo, useEffect, useLayoutEffect, useRef } from 'react';
import { Widget } from '@typeform/embed-react';
import waters from './waters.json'; // Import the waters.json file
import Flickity from 'react-flickity-component';
import 'flickity/css/flickity.css';
import './App.css';
import './trophygrid.css';
import './leaderboard.css'; // Import the leaderboard styles

var Airtable = require('airtable');
const base = new Airtable({ apiKey: 'patc22ivd0lbsVDGh.7d9114ba0cc6cc851aef21c7964a3b2fe712dfda47becf3a13d669888a7cb68c' }).base('app1XGFJ4pW1O36D5');
const PLACEHOLDER_SVG = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(`
  <svg width="350" height="300" xmlns="http://www.w3.org/2000/svg">
    <rect width="100%" height="100%" fill="#E5E5E5"/>
  </svg>
`)}`;
 console.log(PLACEHOLDER_SVG)
function rankSubmissionsByState(submissions) {
  const stateGrouped = submissions.reduce((groups, submission) => {
    if (!groups[submission.state]) {
      groups[submission.state] = [];
    }
    groups[submission.state].push(submission);
    return groups;
  }, {});

  const rankedSubmissions = [];
  Object.keys(stateGrouped).forEach((state) => {
    const stateSubmissions = stateGrouped[state]
      .sort((a, b) => {
        const weightA = parseFloat(a.pounds) + parseFloat(a.ounces) / 16;
        const weightB = parseFloat(b.pounds) + parseFloat(b.ounces) / 16;
        return weightB - weightA; // Sort descending by weight
      })
      .map((submission, index) => ({
        ...submission,
        rank: index + 1, // Assign rank starting from 1
      }));

    rankedSubmissions.push(...stateSubmissions);
  });

  return rankedSubmissions;
}
function formatWeight(pounds, ounces) {
  if (!pounds && !ounces) return '0 lbs';
  const lbs = parseFloat(pounds) || 0;
  const oz = parseFloat(ounces) || 0;
  const totalLbs = lbs + oz / 16;
  return `${totalLbs.toFixed(2)} lbs`;
}

function weightInRange(pounds, ounces, range) {
  const lbs = parseFloat(pounds) || 0;
  const oz = parseFloat(ounces) || 0;
  const totalWeight = lbs + oz / 16;

  // console.log(`Weight Calculated: ${totalWeight} lbs for range: ${range}`);

  switch (range) {
    case '0-5 lbs':
      return totalWeight >= 0 && totalWeight <= 5;
    case '5-8 lbs':
      return totalWeight > 5 && totalWeight <= 8;
    case '8+ lbs':
      return totalWeight > 8;
    default:
      return false;
  }
}
const stateAbbreviations = {
  "Alabama": 'AL',
  "Alaska": 'AK',
  "Arizona": 'AZ',
  "Arkansas": 'AR',
  "California": 'CA',
  "Colorado": 'CO',
  "Connecticut": 'CT',
  "Delaware": 'DE',
  "Florida": 'FL',
  "Georgia": 'GA',
  "Hawaii": 'HI',
  "Idaho": 'ID',
  "Illinois": 'IL',
  "Indiana": 'IN',
  "Iowa": 'IA',
  "Kansas": 'KS',
  "Kentucky": 'KY',
  "Louisiana": 'LA',
  "Maine": 'ME',
  "Maryland": 'MD',
  "Massachusetts": 'MA',
  "Michigan": 'MI',
  "Minnesota": 'MN',
  "Mississippi": 'MS',
  "Missouri": 'MO',
  "Montana": 'MT',
  "Nebraska": 'NE',
  "Nevada": 'NV',
  "New Hampshire": 'NH',
  "New Jersey": 'NJ',
  "New Mexico": 'NM',
  "New York": 'NY',
  "North Carolina": 'NC',
  "North Dakota": 'ND',
  "Ohio": 'OH',
  "Oklahoma": 'OK',
  "Oregon": 'OR',
  "Pennsylvania": 'PA',
  "Rhode Island": 'RI',
  "South Carolina": 'SC',
  "South Dakota": 'SD',
  "Tennessee": 'TN',
  "Texas": 'TX',
  "Utah": 'UT',
  "Vermont": 'VT',
  "Virginia": 'VA',
  "Washington": 'WA',
  "West Virginia": 'WV',
  "Wisconsin": 'WI',
  "Wyoming": 'WY',
};

// Create a mapping from abbreviation to full name
const stateFullNames = Object.fromEntries(
  Object.entries(stateAbbreviations).map(([fullName, abbreviation]) => [
    abbreviation,
    fullName // Keep full name as is
  ])
);

function getStateAbbreviation(stateName) {
  const formattedStateName = stateName.trim().toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
  return stateAbbreviations[formattedStateName] || formattedStateName; // Fallback to full name if abbreviation not found
}

// Utility function to chunk the submissions
const chunkSubmissions = (submissions, size) => {
  const chunked = [];
  for (let i = 0; i < submissions.length; i += size) {
    chunked.push(submissions.slice(i, i + size));
  }
  return chunked;
};

function HeroSection() {
  return (
    <div className="hero-section">
      <div className="header">
        <img className="logo" src="logo.png" alt="logo" />
        <h1>THE TROPHY ROOM</h1>
        <p>What's your PB? We want to see it! Click "Submit your PB" below and enter the details of your catch.</p>
      </div>
    </div>
  );
}

function FilterBar({ setFilters, submissionsUnfiltered, submissions, totalSubmissions  }) {
  const [filterState, setFilterState] = useState('');
  const [filterBodyOfWater, setFilterBodyOfWater] = useState('');
  const [filterWeightRange, setFilterWeightRange] = useState('');
  const [filterRanking, setFilterRanking] = useState('top100');
  const [filterTechnique, setFilterTechnique] = useState('');

  const handleStateFilter = (e) => setFilterState(e.target.value);
  const handleBodyOfWaterFilter = (e) => setFilterBodyOfWater(e.target.value);
  const handleWeightRangeFilter = (e) => setFilterWeightRange(e.target.value);
  const handleRankingFilter = (e) => setFilterRanking(e.target.value);
  const handleTechniqueFilter = (e) => setFilterTechnique(e.target.value);
  
  // Add reset filters function
  const resetFilters = () => {
    setFilterState('');
    setFilterBodyOfWater('');
    setFilterWeightRange('');
    setFilterRanking('top100');
    setFilterTechnique('');
  };

  useEffect(() => {
    const newFilters = {
      state: filterState,
      bodyOfWater: filterBodyOfWater,
      weightRange: filterWeightRange,
      ranking: filterRanking,
      technique: filterTechnique,
    };
    setFilters(newFilters);
  }, [filterState, filterBodyOfWater, filterWeightRange, filterRanking, filterTechnique]);

  // Get all unique states from unfiltered submissions
  const stateOptions = useMemo(() => {
    const uniqueStates = new Set();
    submissionsUnfiltered.forEach(sub => {
      const stateName = stateFullNames[sub.state?.toUpperCase()] || sub.state;
      if (stateName) {
        uniqueStates.add(stateName);
      }
    });
    return Array.from(uniqueStates).sort();
  }, [submissionsUnfiltered]);

  const bodyOfWaterOptions = waters.bodyOfWaters.reduce((options, body) => {
    options[body] = 0; // Initialize count for each body of water
    return options;
  }, {});
  const techniqueOptions = submissionsUnfiltered.reduce((options, sub) => {
    if (sub.technique && !options[sub.technique]) {
      options[sub.technique] = 0;
    }
    if (sub.technique) options[sub.technique]++;
    return options;
  }, {});
  const weightOptions = {
    '8-10 lbs': submissions.filter(sub => weightInRange(sub.pounds, sub.ounces, '8-10 lbs')).length,
    '10-12 lbs': submissions.filter(sub => weightInRange(sub.pounds, sub.ounces, '10-12 lbs')).length,
    '12+ lbs': submissions.filter(sub => weightInRange(sub.pounds, sub.ounces, '12+ lbs')).length
  };

  return (
    <div className="filter-bar-section wrapper">
      <hr className="filter-bar-divider-hr" />
      <div className="filter-bar">
      <div className="filter-bar-header-section">
        <div className="filter-bar-header">
          <p className="subtitle">Angler Gallery</p> 
          <h2>Every Catch, Every Angler</h2>
          <p className="subtitle-sm">Explore PB's From Across the Nation!</p> 
        </div>
      </div>
        <div className="filter-item-container">
          <div className="filter-item state-select">
            <label>STATE:</label>
            <select onChange={handleStateFilter} value={filterState}>
              <option value="">All</option>
              {stateOptions.map(state => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>
          {/* <div className="filter-item">
            <label>BODY OF WATER:</label>
            <select onChange={handleBodyOfWaterFilter} value={filterBodyOfWater}>
              <option value="">All</option>
              {Object.keys(bodyOfWaterOptions).map(body => (
                <option key={body} value={body}>
                  {body}
                </option>
              ))}
            </select>
          </div> */}
          <div className="filter-item">
            <label>WEIGHT CLASS:</label>
            <select onChange={handleWeightRangeFilter} value={filterWeightRange}>
              <option value="">All</option>
              <option value="0-5 lbs">0-5 lbs</option>
              <option value="5-8 lbs">5-8 lbs</option>
              <option value="8+ lbs">8+ lbs</option>
            </select>
          </div>
          <div className="filter-item">
            <label>RANKING:</label>
            <select onChange={handleRankingFilter} value={filterRanking}>
              <option value="">All</option>
              <option value="top1">Best (top 1)</option>
              <option value="top10">Top 10</option>
              <option value="top20">Top 20</option>
              <option value="top50">Top 50</option>
              <option value="top100">Top 100</option>
            </select>
          </div>          
          {/* <div className="filter-item">
            <label>TECHNIQUE:</label>
            <select onChange={handleTechniqueFilter} value={filterTechnique}>
              <option value="">All</option>
              {Object.keys(techniqueOptions).map(technique => (
                <option key={technique} value={technique}>
                  {technique}
                </option>
              ))}
            </select>
          </div> */}
        </div>
        <div className="filter-reset-container">
            <button className="filter-reset-btn" onClick={resetFilters}>Reset Filters</button>
          </div>
        <hr className="filter-hr"></hr>
      </div>

      {/* Submissions count */}
      <div className="submission-count">
        <small>{submissions.length} / {totalSubmissions} submissions</small>
      </div>
    </div>
  );
}

const ImageWithPlaceholder = ({ src, alt, className }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isCover, setIsCover] = useState(true); // State to manage image scale

  const handleImageClick = () => {
    setIsCover(prev => !prev); // Toggle between cover and contain
  };

  return (
    <div className="image-container">
      {isLoading && (
        <div className="image-loading-spinner">
          <div className="spinner"></div>
        </div>
      )}
      <img
        src={src || PLACEHOLDER_SVG}
        alt={alt}
        className={`${className} ${isLoading ? 'loading' : ''}`}
        style={{ objectFit: isCover ? 'cover' : 'contain' }} // Apply the object-fit style
        onLoad={() => setIsLoading(false)}
        onError={(e) => {
          setIsLoading(false);
          e.target.src = PLACEHOLDER_SVG;
        }}
        onClick={handleImageClick} // Add click handler
      />
    </div>
  );
};

const RecentPBsCarousel = ({ submissions }) => {
  const [selectedSubmission, setSelectedSubmission] = useState(null);
  const flickityRef = useRef(null);
  const dotsRef = useRef(null);

  const handleDetailsClick = (submissionId, e) => {
    e.stopPropagation();
    setSelectedSubmission((prev) => (prev === submissionId ? null : submissionId));
  };

  const handleItemClick = (submissionId) => {
    setSelectedSubmission(prev => prev === submissionId ? null : submissionId);
  };

  const formatWeight = (pounds, ounces) => {
    return `${pounds}.${ounces} lbs.`;
  };

  useEffect(() => {
    if (flickityRef.current && dotsRef.current) {     
      const flkty = flickityRef.current;
      // Create custom page dots
      const cellButtons = Array.from({ length: flkty.slides.length }, (_, i) => {
        const button = document.createElement('button');       
        return button;
      });

      dotsRef.current.append(...cellButtons);

      // Update selected cellButtons
      const updateSelectedButton = () => {
        cellButtons.forEach((button, i) => {
          button.classList.toggle('is-selected', i === flkty.selectedIndex);
        });
      };

      flkty.on('select', updateSelectedButton);
      updateSelectedButton();

      // Select cell on button click
      dotsRef.current.addEventListener('click', (event) => {
        if (event.target.matches('button')) {
          const index = cellButtons.indexOf(event.target);
          flkty.select(index);
        }
      });

      return () => {
        if (dotsRef.current) {
          dotsRef.current.innerHTML = '';
        }
      };
    }
  }, [submissions]);

  return (
    <div className="recent-pbs-carousel">
      <div className="wrapper carousel-container">
        <div className="carousel-header-section">
          <div className="carousel-header">
            <h2>RECENT PB'S</h2>
            <p>Check out some recently uploaded PBs and see where you stack up across the nation.</p>
          </div>
          <div className="carousel-dots">
            <div ref={dotsRef} className="carousel-slide-dots"></div>
          </div>
        </div>
        <Flickity
          flickityRef={(c) => (flickityRef.current = c)}
          className="carousel-slides-container"
          elementType="div"
          options={{
            cellAlign: 'left',
            contain: true,
            groupCells: window.innerWidth < 768 ? 1 : 4,
            pageDots: false,
            prevNextButtons: true,
          }}
          disableImagesLoaded={false}
          reloadOnUpdate={false}
          static={false}
        >
         {submissions.map((submission) => (
            <div key={submission.id} className="carousel-cell">       
              <div className="carousel-card"
                   key={submission.id}
                   onClick={() => handleItemClick(submission.id)}>
                <div className="trophy-item-overlay">
                  <ImageWithPlaceholder
                    src={submission.imgSrc}
                    alt={`${submission.firstName} ${submission.lastName[0]}`}
                    className="responsive-img responsive-img-recent"
                  />
                  {submission.rank <= 10 && (
                    <div className="submission-rank">
                      <div className="rank-container">
                        <span className="rank-number"><sub className="rank-number-small">#</sub>{submission.rank}</span>
                        <span className="rank-state">{getStateAbbreviation(submission.state) || submission.state}. TOP 10</span>
                      </div>
                    </div>
                  )}
                  {selectedSubmission === submission.id && (
                    <div className="trophy-details-popup">
                      <div>
                        <h3>PB Stats</h3>
                        <p>
                          <strong>WEIGHT:</strong> {formatWeight(submission.pounds, submission.ounces)}
                        </p>
                        <p>
                          <strong>TECHNIQUE/BAIT:</strong> {submission.technique}
                        </p>
                        {submission.bodyOfWater && (
                          <p>
                            <strong>BODY OF WATER:</strong> {submission.bodyOfWater}
                          </p>
                        )}
                        <p>
                          <strong>STATE:</strong> {stateFullNames[submission.state.toUpperCase()] || submission.state}
                        </p>
                        {submission.memberSince && (
                          <p>
                            <strong>MEMBER SINCE:</strong> {submission.memberSince}
                          </p>
                        )}
                        {submission.rank <= 10 && (
                          <p><strong>RANK:</strong> #{submission.rank} in {getStateAbbreviation(submission.state)}</p>
                        )}
                        {/*  <p>
                          <strong>LAKE:</strong> {submission.lake}
                        </p> */}
                      </div>
                    </div>
                  )}
                </div>
                <div className="carousel-info">
                  <div className="left-side">
                    <span className="initials">
                      {submission.firstName[0]}
                      {submission.lastName[0]}
                    </span>
                    <div className="info-container name-state">
                      <h5>
                        {submission.firstName} {submission.lastName[0]}.
                      </h5>
                      <p className="location">{stateFullNames[submission.state.toUpperCase()] || submission.state}</p>
                    </div>
                  </div>
                  <div className="info-container right-side">
                    <p className="weight">{formatWeight(submission.pounds, submission.ounces)}</p>
                    <p className="details" onClick={(e) => handleDetailsClick(submission.id, e)}>
                      DETAILS <span>{selectedSubmission === submission.id ? '-' : '+'}</span>
                    </p>
                  </div>
                </div>                
              </div>
            </div>
          ))}
        </Flickity>
      </div>
    </div>
  );
};

function extractYear(dateString) {
  const date = new Date(dateString);
  // Check if the date is valid
  if (!isNaN(date.getFullYear())) {
    return date.getFullYear(); // Return the year if valid
  }
  // If not valid, return an empty string
  return '';
}

function LeaderboardModal({ submission, onClose, top }) {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="leaderboard-modal-overlay" onClick={handleOverlayClick}>
      <div
        className="leaderboard-modal"
        style={{ position: 'absolute', top: `${top - 20}px` }} // Top passed from click
      >
        <span className="leaderboard-modal-close" onClick={onClose}>&times;</span>
        <div className="leaderboard-modal-image">
          <ImageWithPlaceholder
            src={submission.imgSrc}
            alt={`${submission.firstName} ${submission.lastName[0]}'s catch`}
            className="responsive-img"
          />
        </div>
        <div className="leaderboard-modal-content">
          <div className="leaderboard-modal-header">
            <h2>{submission.firstName} {submission.lastName[0]}.</h2>
            <p>{stateFullNames[submission.state.toUpperCase()] || submission.state}</p>
          </div>
          <div className="leaderboard-modal-details">
            <div className="leaderboard-modal-detail-item">
              <label>Weight</label>
              <p>{formatWeight(submission.pounds, submission.ounces)}</p>
            </div>
            {submission.technique && (
              <div className="leaderboard-modal-detail-item">
                <label>Technique/Bait</label>
                <p>{submission.technique}</p>
              </div>
            )}
            {submission.bodyOfWater && (
              <div className="leaderboard-modal-detail-item">
                <label>Body of Water</label>
                <p>{submission.bodyOfWater}</p>
              </div>
            )}
            {extractYear(submission.memberSince) && (
              <div className="leaderboard-modal-detail-item">
                <label>Member Since</label>
                <p>{extractYear(submission.memberSince)}</p>
              </div>
            )}
            <div className="leaderboard-modal-detail-item">
              <label>Rank</label>
              <p>#{submission.displayRank || 'N/A'}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


function LeaderboardGrid({ submissions }) {
  const heroBackgroundStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/trophy-leaderboard-hero.jpg)`
  };

  const formatLeaderboardWeight = (pounds, ounces) => {
    return `${pounds} lbs. ${ounces} oz.`;
  };

  const [selectedSubmission, setSelectedSubmission] = useState(null);
  const [modalTop, setModalTop] = useState(0);

  return (
    <>
      <div className="leaderboard-header-section" style={heroBackgroundStyle}>
        <div className="leaderboard-bar-header">
          <h2><span className="pre-highlight">ARE</span> <span className="highlight">YOU</span> <span className="post-highlight">THE</span><br /><span className="under-highlight">LAKE LEADER?</span></h2>
          <p className="subtitle">TROPHY ROOM LEADERBOARD</p>
        </div>
      </div>

      <div className="leaderboard-grid">
        <div className="leaderboard-header">
          <div className="rank-column">Rank</div>
          <div className="angler-column">Angler Name</div>
          <div className="weight-column">PB Weight</div>
          <div className="bait-column">Bait</div>
          <div className="state-column">State</div>
          <div className="lake-column">Lake/Body of Water</div>
        </div>
        <hr className="leaderboard-hr" />
        <div className="leaderboard-items-container">
          {submissions.map((submission, index) => (
            <div
              key={submission.id}
              className="leaderboard-item"
              onClick={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                const modalY = window.scrollY + rect.top;
                setModalTop(modalY);
                setSelectedSubmission({ ...submission, displayRank: index + 1 });
                window.parent.postMessage({ action: 'openLeaderboardModal', position: modalY }, '*');
              }}
              style={{ cursor: 'pointer' }}
            >
              <div className="rank-column"><div className="rank-placement">{index + 1}</div></div>
              <div className="angler-column">
                <span className="initials">
                  <ImageWithPlaceholder
                    src={submission.imgSrc}
                    alt={`${submission.firstName} ${submission.lastName[0]}`}
                    className="responsive-img responsive-img-recent"
                  />
                </span>
                <div className="info-container">
                  <h5>{submission.firstName} {submission.lastName[0]}.</h5>
                  <p className="location">{submission.state}</p>
                </div>
              </div>
              <div className="weight-column">
                {formatLeaderboardWeight(submission.pounds, submission.ounces)}
              </div>
              <div className="bait-column">
                {submission.technique || '-'}
              </div>
              <div className="state-column">
                {stateFullNames[submission.state.toUpperCase()] || submission.state}
              </div>
              <div className="lake-column">
                {submission.bodyOfWater || '-'}
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedSubmission && (
        <LeaderboardModal
          submission={selectedSubmission}
          onClose={() => setSelectedSubmission(null)}
          top={modalTop}
        />
      )}
    </>
  );
};

const TrophyRoomGrid = ({ submissions }) => {
  const [selectedSubmission, setSelectedSubmission] = useState(null);

  // Use useMemo to chunk the submissions directly without any additional sorting
  const chunkedSubmissions = useMemo(() => {
    // Create a copy of submissions to avoid mutating the original array
    const submissionsCopy = [...submissions];
    return chunkSubmissions(submissionsCopy, window.innerWidth < 768 ? 2 : 8);
  }, [submissions]);

  // Prevent Flickity from resetting when clicking on a submission
  const handleDetailsClick = (submissionId, e) => {
    e.stopPropagation(); // Prevent Flickity from considering it a drag action
    setSelectedSubmission(prev => prev === submissionId ? null : submissionId);
  };

  const handleItemClick = (submissionId) => {
    setSelectedSubmission(prev => prev === submissionId ? null : submissionId);
  };

  const formatWeight = (pounds, ounces) => {
    return `${pounds}.${ounces} lbs.`;
  };

  return (
    <>
      <div className="trophy-room-container">
      
      <Flickity
        className={'trophy-room'}
        elementType={'div'}
        options={{
          cellAlign: 'left',
          contain: true,
          groupCells: window.innerWidth < 768 ? 1 : 1,
          pageDots: true,
          prevNextButtons: true,
          dragThreshold: 10,
          freeScroll: false,
          setGallerySize: false,
          adaptiveHeight: window.innerWidth < 768, // Enable adaptive height on mobile
          // Important: preserve the carousel position
        }}
        disableImagesLoaded={false}
        reloadOnUpdate={false} // Avoid reload on every update to preserve position
        static={false}
      >
        {chunkedSubmissions.map((submissionGroup, index) => (
          <div className="carousel-cell slide-div" key={`group-${index}`}>
            {submissionGroup.map((submission) => (
              <div 
                className="trophy-item" 
                key={submission.id}
                onClick={() => handleItemClick(submission.id)}
              >
               {submission.rank <= 10 && (
                  <div className="submission-rank">
                  <div className="rank-container">
                    <span className="rank-number"><sub className="rank-number-small">#</sub>{submission.rank}</span>
                    <span className="rank-state">{getStateAbbreviation(submission.state)}. TOP 10</span>
                  </div>
                </div>
              )}
                 <div className="trophy-item-overlay">
                <ImageWithPlaceholder
                  src={submission.imgSrc}
                  alt={`${submission.firstName} ${submission.lastName[0]}`}
                  className="responsive-img responsive-img-trophy"
                />
                {selectedSubmission === submission.id && (
                  <div className="trophy-details-popup">
                    <div>
                      <h3>PB Stats</h3>
                      <p><strong>WEIGHT:</strong> {formatWeight(submission.pounds, submission.ounces)}</p>
                      <p><strong>TECHNIQUE/BAIT:</strong> {submission.technique}</p>
                      {submission.bodyOfWater && (
                          <p>
                            <strong>BODY OF WATER:</strong> {submission.bodyOfWater}
                          </p>
                        )}
                      <p><strong>STATE:</strong> <span className="popup-state">{stateFullNames[submission.state.toUpperCase()] || submission.state.toLowerCase()}</span></p>
                      {submission.memberSince && (
                          <p>
                            <strong>MEMBER SINCE:</strong> {submission.memberSince}
                          </p>
                      )}
                      {submission.rank <= 10 && (
                        <p><strong>RANK:</strong> #{submission.rank} in <span className="popup-rank-state">{getStateAbbreviation(submission.state)}</span></p>
                      )}
                      {/* <p><strong>LAKE:</strong> {submission.lake}</p> */}
                    </div>
                  </div>
                )}
                </div>
                <div className="carousel-info">
                  <div className="left-side">
                    <span className="initials">
                      {submission.firstName[0]}{submission.lastName[0]}
                    </span>
                    <div className="info-container name-state">
                      <h5>
                        {submission.firstName} {submission.lastName[0]}.
                      </h5>
                      <p className="location">{stateFullNames[submission.state.toUpperCase()] || submission.state}</p>
                    </div>
                  </div>
                  <div className="info-container right-side">
                    <p className="weight">{formatWeight(submission.pounds, submission.ounces)}</p>
                    <p 
                      className="details" 
                      onClick={(e) => handleDetailsClick(submission.id, e)}
                    >
                      DETAILS <span>{selectedSubmission === submission.id ? '-' : '+'}</span>
                    </p>
                  </div>
                </div>
             
              </div>
            ))}
          </div>
        ))}
      </Flickity>
    </div>
    </>
  );
};

function App() {
  const [submissions, setSubmissions] = useState([]);
  const [allSubmissions, setAllSubmissions] = useState([]); // Raw submissions sorted by date
  const [rankedSubmissions, setRankedSubmissions] = useState([]); // Ranked by state
  const [filters, setFilters] = useState({
    state: '',
    technique: '',
    weightRange: '',
    bodyOfWater: '',
    ranking: ''
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    let isMounted = true;
    const fetchSubmissions = async () => {
      try {
        let fetchedSubmissions = [];
        await base('Approvals')
          .select({
            maxRecords: 500,
            view: "Grid view",
            sort: [{ field: 'Approved Date', direction: 'desc' }],
          })
          .eachPage((records, fetchNextPage) => {
            records.forEach((record) => {
              const approvedDate = new Date(record.get('Approved Date'));
              const monthNames = [
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
              ];
              const monthName = monthNames[approvedDate.getMonth()];

              const subState = record.get('State').charAt(0).toUpperCase() + record.get('State').toLowerCase().slice(1)

              const imageAttachments = record.get('Upload Image');
              let imgSrc = '';
              if (imageAttachments && imageAttachments.length > 0) {
                const attachment = imageAttachments[0];
                imgSrc = attachment.thumbnails?.large?.url || attachment.url;
              }

              fetchedSubmissions.push({
                id: record.id,
                firstName: record.get('First Name').charAt(0).toUpperCase() + record.get('First Name').toLowerCase().slice(1),
                lastName: record.get('Last Name').charAt(0).toUpperCase() + record.get('Last Name').toLowerCase().slice(1),
                pounds: record.get('Pounds (lbs.)') || '',
                ounces: record.get('Ounces (oz.)') || '',
                state: stateFullNames[record.get('State')] || subState, 
                memberSince: record.get('Member Since'),
                month: monthName,
                technique: record.get('Technique/Bait used'),
                bodyOfWater: record.get('Body of water'),
                imgSrc: imgSrc,
                createdTime: record.get('Approved Date'),
              });
            });
            fetchNextPage();
          });

        if (isMounted) {
          // Sort by date descending (most recent first)
          const sortedByDate = fetchedSubmissions.sort((a, b) => 
            new Date(b.createdTime) - new Date(a.createdTime)
          );
          
          setAllSubmissions(sortedByDate);
          const ranked = rankSubmissionsByState(fetchedSubmissions);
          setRankedSubmissions(ranked);
          setSubmissions(sortedByDate.map((submission, index) => ({
            ...submission,
            rank: ranked.findIndex(r => r.id === submission.id) + 1 // Calculate rank based on the ranked submissions
          })));
        }
      } catch (error) {
        console.error("Error fetching submissions:", error);
      }
    };

    fetchSubmissions();
    return () => {
      isMounted = false;
    };
  }, []);

  // Update submissions when filters change
  useEffect(() => {
    const hasActiveFilters = Object.values(filters).some(filter => filter !== '');
    
    if (hasActiveFilters) {
      // Start with all submissions
      let filtered = [...allSubmissions];
      
      filtered = filtered.filter((submission) => {
        const stateAbbreviation = getStateAbbreviation(submission.state.toUpperCase());
        const stateFull = stateFullNames[submission.state.toUpperCase()] || submission.state.toLowerCase();
        const isStateMatch = filters.state ? 
          (stateFull.toLowerCase() === filters.state.toLowerCase()) : true;
        
        // First filter by weight range if specified
        const isWeightMatch = filters.weightRange ? 
          weightInRange(submission.pounds, submission.ounces, filters.weightRange) : true;
        
        // Calculate rank within weight class if weight range is specified
        let rank;
        if (filters.ranking) {
          const submissionsToRank = filters.state ? 
            // If state filter is active, rank within state
            allSubmissions.filter(s => s.state === submission.state) :
            // If no state filter, rank globally
            allSubmissions;
            
          // Further filter submissionsToRank by weight class if specified
          const weightFilteredSubmissions = filters.weightRange ?
            submissionsToRank.filter(s => weightInRange(s.pounds, s.ounces, filters.weightRange)) :
            submissionsToRank;
            
          const sortedSubmissions = weightFilteredSubmissions
            .sort((a, b) => {
              const weightA = parseFloat(a.pounds) + parseFloat(a.ounces) / 16;
              const weightB = parseFloat(b.pounds) + parseFloat(b.ounces) / 16;
              return weightB - weightA;
            });
          rank = sortedSubmissions.findIndex(s => s.id === submission.id) + 1;
        }
        
        return (
          isStateMatch &&
          isWeightMatch &&
          (filters.technique ? submission.technique === filters.technique : true) &&
          (filters.bodyOfWater ? submission.bodyOfWater === filters.bodyOfWater : true) &&
          (filters.ranking === 'top1' ? rank === 1 : 
           filters.ranking === 'top10' ? rank <= 10 : 
           filters.ranking === 'top20' ? rank <= 20 :
           filters.ranking === 'top50' ? rank <= 50 :
           filters.ranking === 'top100' ? rank <= 100 : true)
        );
      });

      // Always sort by weight when weight range or ranking filter is active
      if (filters.weightRange || filters.ranking) {
        filtered.sort((a, b) => {
          const weightA = parseFloat(a.pounds) + parseFloat(a.ounces) / 16;
          const weightB = parseFloat(b.pounds) + parseFloat(b.ounces) / 16;
          return weightB - weightA;
        });
      } else {
        filtered.sort((a, b) => new Date(b.createdTime) - new Date(a.createdTime));
      }
      
      setSubmissions(filtered);
    } else {
      // Use date-sorted submissions when no filters are active
      setSubmissions([...allSubmissions]);
    }
  }, [filters, allSubmissions]);

  // Function to open the modal
  const openModal = () => {
    setIsModalOpen(true);
    setIsLoading(true); // Set loading to true when opening the modal
    setScrollPosition(window.scrollY); // Store current scroll position
    document.body.style.overflow = 'hidden'; // Disable scrolling on the parent document
    window.parent.postMessage({ action: 'scrollToModal' }, '*');
    // Load Typeform script
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.onload = () => setIsLoading(false); // Set loading to false when script loads
    document.body.appendChild(script);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setIsLoading(true); // Reset loading state when closing
    document.body.style.overflow = 'auto'; // Re-enable scrolling on the parent document
    window.parent.postMessage({ action: 'scrollToPosition', position: scrollPosition }, '*');
    const script = document.querySelector('script[src="//embed.typeform.com/next/embed.js"]');
    if (script) {
      document.body.removeChild(script);
    }
  };

  // Function to close the modal when clicking outside of it
  const handleClickOutside = (e) => {
    const modalContent = document.querySelector('.pb-form-modal-content');
    if (modalContent && !modalContent.contains(e.target)) {
      closeModal();
    }
  };

  useEffect(() => {
    // Add event listener for clicks outside the modal
    if (isModalOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isModalOpen]);

  return (
    <div className="App">
      <ErrorBoundary>
        <RecentPBsCarousel 
          submissions={[...allSubmissions]
            .sort((a, b) => new Date(b.createdTime) - new Date(a.createdTime))
            .slice(0,8)} 
        />
        <LeaderboardGrid 
          submissions={[...allSubmissions]
            .sort((a, b) => {
              const weightA = parseFloat(a.pounds) + parseFloat(a.ounces) / 16;
              const weightB = parseFloat(b.pounds) + parseFloat(b.ounces) / 16;
              return weightB - weightA;
            })
            .slice(0, 10)} 
        />
        <FilterBar 
          setFilters={setFilters}
          submissionsUnfiltered={rankedSubmissions} 
          submissions={submissions} 
          totalSubmissions={allSubmissions.length} 
        />
        <TrophyRoomGrid submissions={submissions} />
      </ErrorBoundary>
      
      {/* Button to open the modal */}
      <button className="submit-button" onClick={openModal}>Submit Your PB</button>

      {/* Modal for the form */}
      {isModalOpen && (
        <div className="pb-form-modal">
          <div className="pb-form-modal-content" data-tf-live="01JCRQ19TZ7NYMYPTWDRBAJRW3">
            <span className="pb-form-close" onClick={closeModal}>&times;</span>
            <Widget 
              id="01JCRQ19TZ7NYMYPTWDRBAJRW3"
              style={{ width: '100%', height: '500px' }} // Adjust the size as needed
              onLoad={() => console.log('Typeform loaded')}
            />
          </div>
        </div>
      )}
    </div>
  );
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught in ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}

export default App;
